import { message } from "antd";
import { AirdropType } from "../../../type";
import { IoCopy } from "react-icons/io5";
import { shortenAddress } from "../../../helpers";
import { getAddress } from "@ethersproject/address";

const AirdropInfo = ({ airdrop }: { airdrop: AirdropType | undefined }) => {
  const [messageApi, contextHolder] = message.useMessage();

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(airdrop?.token.address ?? "");
      messageApi.open({
        type: "success",
        content: "Copied to clipboard!",
      });
    } catch (err) {
      messageApi.open({
        type: "error",
        content: "An error occurred!",
      });
    }
  };

  const handleAddToken = async () => {
    if (!window.ethereum) {
      alert("Please install MetaMask!");
      return;
    }

    let tokenAddress = airdrop?.token.address || "";

    try {
      tokenAddress = getAddress(tokenAddress);
    } catch (error) {
      messageApi.open({
        type: "error",
        content: "Invalid contract address",
      });
      return;
    }

    try {
      const wasAdded = await window.ethereum.request({
        method: "wallet_watchAsset",
        params: {
          type: "ERC20",
          options: {
            address: tokenAddress,
            symbol: airdrop?.token?.symbol || "",
            decimals: airdrop?.token.decimals || "",
            image: airdrop?.token.logo || "",
          },
        },
      });

      if (wasAdded) {
        messageApi.open({
          type: "success",
          content: "Token added successfully!",
        });
      }
    } catch (error) {
      messageApi.open({
        type: "error",
        content: "Failed to add token!",
      });
    }
  };

  return (
    <>
      {contextHolder}
      <div className="w-full">
        <div className="bg-backgroundWhite p-4 flex flex-col md:flex-row lg:flex-col gap-4 text-text-secondary">
          <div className="w-full flex flex-col lg:flex-row justify-between gap-3">
            <div className="w-full lg:w-1/3 flex flex-col items-start gap-1 text-base">
              <div>Token Address</div>
              <div className="flex items-center gap-2">
                <div className="font-semibold">
                  {shortenAddress(airdrop?.token.address ?? "")}
                </div>
                <IoCopy
                  onClick={copyToClipboard}
                  className="cursor-pointer text-[#292D32]"
                  size={18}
                />
                <button
                  onClick={() => handleAddToken()}
                  className="bg-[#3DBFD1] bg-opacity-10 text-[#3DBFD1] px-2 py-1 rounded-md text-base"
                >
                  Add to Metamask
                </button>
              </div>
            </div>
            <div className="w-full lg:w-1/3 flex flex-col items-start gap-1 text-base">
              <div>Name</div>
              <div className="font-semibold">{airdrop?.title}</div>
            </div>
            <div className="w-full lg:w-1/3 flex flex-col items-start gap-1 text-base">
              <div>Symbol</div>
              <div className="font-semibold flex items-center gap-[6px]">
                <img
                  src={airdrop?.token.logo}
                  alt="logo"
                  className="h-5 w-5 object-contain"
                />
                {airdrop?.token.symbol}
              </div>
            </div>
          </div>
          <div className="w-full flex flex-col lg:flex-row justify-between gap-3">
            <div className="w-full lg:w-1/3 flex flex-col items-start gap-1 text-base">
              <div>Token Reward</div>
              <div className="font-semibold">
                {airdrop?.total_rewards_string}
              </div>
            </div>
            <div className="w-full lg:w-1/3 flex flex-col items-start gap-1 text-base">
              <div>Network</div>
              <div className="font-semibold flex items-center gap-[6px]">
                <img
                  src={airdrop?.token.chain.logo}
                  alt="logo"
                  className="h-5 w-5 object-contain"
                />
                {airdrop?.token.chain.name}
              </div>
            </div>
            <div className="w-full lg:w-1/3 flex flex-col items-start gap-1 text-base">
              <div>Winners</div>
              <div className="font-semibold">{airdrop?.winners}</div>
            </div>
          </div>
        </div>
        <div className="w-full h-auto flex justify-end">
          <img
            src="/images/line-open.png"
            alt=""
            className="max-w-full w-[500px] h-auto"
          />
        </div>
      </div>
    </>
  );
};

export default AirdropInfo;
